import React, { useState, useEffect, useRef} from 'react';
import { useParams , useNavigate} from 'react-router-dom';
import axios from 'axios';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import { DataGrid  } from '@mui/x-data-grid';
import '../App.css';
import AxiosFetchData from './AxiosFetchData.js'
import { setValue } from '@syncfusion/ej2-base';
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
import { DialogFormTemplate } from './template';
import { ColumnDirective, ColumnsDirective, TreeGridComponent,RowDD,Inject , Aggregate, AggregatesDirective } from '@syncfusion/ej2-react-treegrid';
import { Edit, Toolbar, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, extendArray   } from '@syncfusion/ej2-react-treegrid';
import { getValue } from '@syncfusion/ej2-base';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import VirtualizedSelect from 'react-virtualized-select';
import Button from '@mui/material/Button';
import { dataSourceChanged, getObject } from '@syncfusion/ej2-grids';
import Layout from './Layout.js';
import Helper from './Helper.js';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import PrintPreview from './PrintReview.js';

const EditInvoice =   () => {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [confirmTaskOpen,setConfirmTaskOpen] = useState(false);
    const [open, setOpen] =  useState(false);
    const [dataTask, setDataTask] = useState({});
    const [taskName, setTaskName] = useState({});
    const [taskDate, setTaskDate] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [delegasiList, setDelegasiList] = useState([]);
    const [prioritasList, setPrioritasList] = useState([]);
    const [selectedPrioritas, setSelectedPrioritas] = useState('');
    const [action, setAction] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [selectedDelegasi, setSelectedDelegasi] = useState('');
    const [kemajuan, setKemajuan] = useState(0);
    const [idTask, setIdTask] = useState('');
    const [confirmDeleteOpen,setConfirmDeleteOpen] = useState(false);
    const [layout, setLayout] = useState('Task');
    const [timelineSetting, setTimelineSetting] = useState({});
    const inputRef =  useRef(null);
    const [partNo, setPartNo] = useState('');
    const [qty ,setQty] = useState(0);
    const [description ,setDescription] = useState(0);
    const [price ,setPrice] = useState(0);
    const [tipeAction ,setTipeAction] = useState(0);
    const [total ,setTotal] = useState(0);
    const [totalOrigin ,setTotalOrigin] = useState(0);
    const [grandTotal ,setGrandTotal] = useState(0);
    const [isLastId ,setIsLastId] = useState(true);
    const Navigate = useNavigate()
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('ReturnUrl');
    const [persentase ,setPersentase] = useState(0);
    const [projectId, setProjectId] = useState('');
    const [message ,setmessage] = useState('');
    const [retensi ,setRetensi] = useState(0);
    const [retensiVal ,setRetensiVal] = useState(0);
    const [totalAfterRetention ,setTotalAfterRetention] = useState(0);
    const [InvoiceType ,setInvoiceType] = useState('Percent');
    const [persentaseNominal ,setPersentaseNominal] = useState(0);
    const [rev, setRev] =  useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [revTemp, setRevtemp] =  useState(0);
    const [revDefault, setRevDefault] =  useState(0);
    const [revRows, setRevRows] =  useState([]);
    const [invoiceCode ,setInvoiceCode] = useState('');
    const menuOpen = Boolean(anchorEl);
    const [treedata ,setTreedata] = useState('');
    const [tax, setTax] =  useState(0);
    const [invNo ,setInvNo] = useState('');
    const [customer ,setCustomer] = useState('');
    const [roleAccess, setRoleAccess] = useState([]);

    const handleClick = (event,data) => {
       setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
      setAnchorEl(null);
    };


    useEffect(  () => {
          GetTaskList();
     }, [Navigate]);


    const GetRetention = async (persentase, persentaseNominal=null) => {
      try{
        var response =  await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate);
        if(response){
          response = await AxiosFetchData.get(`GetRetention/${response.data.resp.project_id}`).refreshToken(Navigate);
          if(response){
            if(persentase == 100  || (persentaseNominal && (persentaseNominal == 100))){
             setRetensi(response.data.retensi)
            }else{
              setRetensi(0)
            }
            
          }
        }
         
      }catch(err){
        setmessage(err.message)
      }
      
      
    }
    const GetTaskList = async () => {
       try{
         
        const response = await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate,"invoice")
      
        if(response){   
            const rowsWithRowNumbers = response.data.data.map((row, index) => ({
             //    ...row,
            //    rowNumber: index + 1,
                rowNumber: index + 1,
                invoice_id: row.invoice_id,
                part_no: row.part_no,
                descriptions: row.descriptions,
                newqty: row.newqty,
                price: row.price,
                expanded : row.expanded,
                type:row.type,
                code :row.code,
                unit_name:row.unit_name,
                subChild:row.subChild,
              }));
              setRoleAccess(response.roleaccess)
              setRows(rowsWithRowNumbers);
              setTax(response.data.quotation.tax)
              setTotal(response.data.resp.total);
              setInvoiceCode(response.data.resp.kode);
              setTotalOrigin(response.data.resp.total_all)
              setProjectId(response.data.resp.project_id)
              setCustomer(response.data.resp.kode.split('/')[2])
              
              setPersentase(response.data.resp.type == "Percent" ? response.data.resp.persentase : response.data.resp.total);
              if(response.data.resp.type == "Nominal"){
                setPersentaseNominal(response.data.resp.persentase)
               
              }
              setRevtemp(response.data.resp.rev)
              setRev(response.data.resp.rev)
              setDescription(response.data.resp.deskripsi);
              setInvoiceType(response.data.resp.type)
              if(response.data.customer[0].lastId == id){
                    setIsLastId(false);
              }

              await GetRetention(response.data.resp.persentase)
              await  GetRev();
        }
       }catch(e){
          setmessage(e.message);
       }
        
       
    }

    const AddTask = async (e) => {
        e.preventDefault(); 
       if(action === 'AddParent'){
        var data = {
          invoice_id : Math.random().toString().split('.')[1],
          part_no :partNo,
          descriptions : description,
          newqty:qty,
          price : price
        }
       }
    
       setConfirmTaskOpen(false)
    }
  

    const onChange = (args,data,tipe) => {
     
        setSelectedType('')
        setPartNo('')
        setDescription('')
        setQty(0)
        setPrice(0)
        setAction(tipe);  
        setDataTask(data);
        setConfirmTaskOpen(true)
    };

    const onDelete = (args,data,tipe) => {
        setTaskName(data.name)
        setIdTask(data.id)
        //alert(data.id)
        setConfirmDeleteOpen(true)
    }
     
    async function handleDeleteConfirmation(){
      try{
        const response = await AxiosFetchData.delete(`DeleteTask/${idTask}`).refreshToken(Navigate);
        if(response){
            setConfirmDeleteOpen(false);
            setmessage(response.data)
            await GetTaskList()
        }
      }catch(err){
        setmessage(err.message)
      }
       
    }

    async function fetchdata(id){
        const response = await AxiosFetchData.get(`GetTask/${id}`).refreshToken(Navigate);
       // console.log(response.data.is_milestone);
        if(response){
            
            setSelectedType(response.data.is_milestone);
            setTaskName(response.data.name)
            var data = [...taskDate]
            data[0] = response.data.sebenarnya_mulai == null ? null : new Date(response.data.sebenarnya_mulai);
            data[1] = response.data.sebenarnya_selesai == null ? null : new Date(response.data.sebenarnya_selesai);
            setTaskDate(data);
            setKemajuan(response.data.kemajuan)
            setSelectedStatus(response.data.id_status)
            setSelectedPrioritas(response.data.id_prioritas)
            setSelectedDelegasi(response.data.id_level)
            setIdTask(response.data.id_treeview)
        }
    }

    const AddParentTask = async () => {
         try{
          // alert(grandTotal)
          // alert(totalOrigin)
          // alert(total)
          var response;
          if(grandTotal !== total)  
          {
            
            setmessage("total should be the same as invoice")
            return;
          }

          var data ={
            data : JSON.stringify(treegrid.getCurrentViewRecords()),
            id:id,
            deskripsi: description, 
            persentase: InvoiceType == "Percent" ? persentase : persentaseNominal,
           
            total : totalAfterRetention,
            total_all : totalOrigin,
            retensiVal : retensiVal,
            type : InvoiceType,
            rev : rev,
            kode : invoiceCode
          }
  
          if(revTemp == rev){
           // alert('sama')
              response = await AxiosFetchData.post("EditInvoice",data).refreshToken(Navigate);
          }

          if(revTemp != rev){
            delete data.id;
           // alert('beda')
            data.status = "Unpaid";
            data.tanggal = Helper.GetDateYYYYMMDD(new Date());
            data.project_id = projectId;
            data.rev = rev;
            data.rev_default= 0;
            data.kode = invoiceCode;

            response = await AxiosFetchData.post("AddInvoice",data).refreshToken(Navigate);
          }
         
          if(response){
              setmessage(response.data)
              Navigate(`/${myParam}`)
      
          }
         }catch(err){
            setmessage(err.message)
         }
        
    };
   

      function handleTimeline(tipe){
        if(tipe=="month"){
            const timelineSettings = {
                timelineUnitSize: 150,
           
                  bottomTier: {
                 
                  unit: 'Month',
                 
            }
              };
              setTimelineSetting(timelineSettings)
        }else if(tipe=="week"){
            const timelineSettings = {
             
                  bottomTier: {
                    timelineUnitSize: 150,
                  unit: 'Week',
                  format: 'MMM dd, yyyy',
                
            }
              };
              setTimelineSetting(timelineSettings)
        }else{
        
            const timelineSettings = {
                timelineUnitSize: 100,
             
                  bottomTier: {
                  unit: 'Day',
                    format: 'MMM dd, yyyy',
                  
            }
              };
              setTimelineSetting(timelineSettings)
        }
    
    }
        
    let treegrid;
    const toolbarOptions = ['Add', 'Edit', 'Delete',  { text: 'Clear', tooltipText: 'Clear', id: 'toolbarfilter', align: 'Right' },{ text: 'Default', tooltipText: 'Default', id: 'toolbarfilter2', align: 'Right' },{ text: 'Preview', tooltipText: 'Preview', id: 'toolbarfilter3', align: 'Right' }];
    const dialogTemplate = (props) => {
        const obj = [props, treegrid];
        return (<DialogFormTemplate {...obj}/>);
    };
    const editOptions = {
        allowAdding: true,
        allowDeleting: true,
        allowEditing: true,
        mode: 'Dialog',
        newRowPosition: 'Child',
        template: dialogTemplate
    };

    const actionComplete = (args) => {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
            const form = args.form;
            if (args.requestType === 'beginEdit') {
              console.log(args.form.elements.namedItem("part_no"))
            }
        }

        if (args.requestType === 'save') {
          
        }
    };

    const actionBegin = (args) => {
     // alert(args.requestType)
        if (args.requestType === 'save') {
            // cast string to integer value.
            // const val = args.form
            //     .querySelector("#qty").value;
            // setValue('data.qty', parseFloat(val), args);
        }

        if ((args.requestType === 'add')) {
          // const val = args.form.querySelector("#invoice_id").value;
            setValue('data.invoice_id',Math.random().toString().split('.')[1], args);
            setValue('data.type',"new", args);
        }

        if ((args.requestType === 'delete')) {
          // if(args.data[0].type != "new" && args.data[0].type != "title" && args.data[0].type != "null"){
          //   args.cancel = true;
          //   setmessage("cannot be deleted");
          // }
        }
    };

    function  rowDrop(args) {
      
      if (args.dropPosition == 'middleSegment' || Object.keys( args.dropPosition).length == 0) {
         args.cancel = true;
         treegrid.reorderRows([args.fromIndex], args.dropIndex, 'above');
      }
    }
    const selectionSettings = { type: 'Multiple' };

    const TotalTemplate = (props) => {
       if (getObject('price', props) != null && getObject('newqty', props) != null) {
            return Helper.formatAsCurrency((getObject('price', props) * getObject('newqty', props)));
         }
         return null;
      
    };

    const priceTemplate = (field, data, column) => {
      if (getValue('price', data) != null) {
        return  Helper.formatAsCurrency(getValue('price', data));
      }
      return null;
    };
 
    const customAggregateFn = (row) => {
        const sampleData = getObject('result', row);
       // console.log(sampleData)
        let data = 0;
        if(sampleData){
            sampleData.filter((item) => {
                if(getObject('price', item) && getObject('newqty', item)){
                    data += getObject('price', item) * getObject('newqty', item);
                }
                  
                
            });
        }
       //  alert(data)
        setGrandTotal(data)
        return data;
    };

  const custom1 = (props) => {
      return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total :</td><td>{(Helper.formatAsCurrency(getObject('Custom', props)))}</td></tr></table>)
     // return (<span>Total :  {(Helper.formatAsCurrency(getObject('Custom', props)))}</span>);
  };

  const custom =   (props) => {
    return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>inv{InvoiceType=="Percent" ? "(" + persentase + '%)' : ''} :</td><td>{Helper.formatAsCurrency(total)}</td></tr></table>)
   //return (<span>inv({persentase}%) :  {Helper.formatAsCurrency(total)}</span>);
   // return (<span>inv({total}%) :  {(getObject('Custom', props) * (total/100))}</span>);
  };

  const custom2 =    (props) => {
      setRetensiVal(totalOrigin * (retensi / 100));
      return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Retention({retensi}%) :</td><td>{Helper.formatAsCurrency(totalOrigin * (retensi / 100))}</td></tr></table>)
   };

   
   const custom3 =    (props) => {
      setTotalAfterRetention(total - (totalOrigin * (retensi / 100)));
      return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Grand Total:</td><td>{Helper.formatAsCurrency(total - (totalOrigin * (retensi / 100)))}</td></tr></table>)
   };
    

    async function handleTotal(data)
    {
      if(!data){
        data = 0;
       }
     
       var index = 0;
       if(data.toString().length > (((data * 1).toString())).length){
         index = data.toString().length - (((data * 1).toString())).length
       }
     
       data = data.toString().substring(index)

      if(parseFloat(data) > 100 && InvoiceType == 'Percent'){
        setmessage("must be smaller than 100%")
        return;
      }
    
      setPersentase(data)
      //if(persentase.toString().substring(0,1) == "0"){
      // setPersentase(parseInt(data.toString().substring(1)))
      //}else{
      //  setPersentase(data)
     // }
      
      try
      {
        const response = await AxiosFetchData.get(`GetInv/${projectId}/${data}/${totalOrigin}/${id}/${InvoiceType}/${rev}`).refreshToken(Navigate);
        if(response){
          setTotal(response.data.value);
          if(InvoiceType == "Nominal"){
            setPersentaseNominal(response.data.persentase);
            if(response.data.persentase > 100 && InvoiceType == 'Nominal'){
              setmessage("must be smaller than 100%")
              setPersentase(0)
              setTotal(0)
              return;
            }
          }
          await GetRetention(data, response.data.persentase)
         }
      }catch(e){
        setmessage(e.message)
      }
    }

    const toolbarClick = (args) => {
      
      if ( args.item.text ==='Clear') {
          setRows([])
      }
    
      if ( args.item.text ==='Default') {
          GetTaskList();
      }

      if (args.item.text ==='Preview') {
          var data = {
              treeview : treegrid.getCurrentViewRecords(),
              invoice : {
                persentase : persentase,
                //retensi : totalOrigin * (retensi / 100),
                total_all :  totalOrigin,
                total : total,
                kode : invoiceCode,
                tax : tax
              },
              retensi : retensi
            
          }
         // alert(tax)
          //setTreedata(JSON.stringify(treegrid.getCurrentViewRecords()))
          setTreedata(JSON.stringify(data))
          setOpen(true);
      }
      
    };

    const handleRev = async (type) => {
      const response = await AxiosFetchData.get(`GetLastRev/${projectId}/${id}/${encodeURIComponent(invoiceCode)}`).refreshToken(Navigate);
      
      if(response){
          if(type=='add'){
              setRev(parseInt(response.data) + 1)
          }else{
              setRev(revTemp)
          }
          
          setAnchorEl(null);
      }
      
  }

  async function handleDefault(){
    try{
        const response = await AxiosFetchData.get(`SetDefaultInvoice/${id}/${revTemp}/${rev}`).refreshToken(Navigate);
        if(response){
            
            setmessage(response.data);
            await GetRev();
            setAnchorEl(null)
        }
    }catch(err){
        setmessage(err.message);
    }
    
  }

  async function GetRev(){
    try{
        var response = await AxiosFetchData.get(`GetInvoiceRev/${id}`).refreshToken(Navigate);
       
        if(response.data){
            const rowsWithRowNumbers = response.data.map((row, index) => ({
                ...row,
                rowNumber: index + 1,
               
            }));

            setRevRows(rowsWithRowNumbers)
           
        }
    }catch(e){
        setmessage(e.message)
    }
   
  }

  const revColumns= [
    { field: 'rowNumber', headerName: 'No.', width: 50 },
    // { field: 'id', headerName: 'ID.', width: 250, hideable: false},
    //   { field: 'default_rev', headerName: 'Default.', width: 100 },
    {
        field: 'action',
        headerName: '',
        width: 150,
       
        renderCell: (params) => (
          <>
           <Button    
               onClick={() => Navigate(`/EditInvoice/${params.row.id}?ReturnUrl=${myParam}`)} // Pass the project ID to the edit function
            //  className="btn btn-primary mr-2"
             >
             <ModeEditIcon  sx={{ fontSize: 15 }}/>
            </Button>
           &nbsp; 
           <ConfirmationButton disabled={roleAccess.DELETE == true ? (isLastId) : !roleAccess.DELETE} classname='btn btn-danger' text="Do you want delete this data?" type="button" title="Delete"  onClick={() => handleDeleteRev(params.row.id,params.row.rev_default)} >
                      <DeleteForeverIcon sx={{fontSize:15}} />
           </ConfirmationButton>
           
          </>
          
        ),
    },
    {
        field: 'isDefault',
        headerName: 'Default',
        width: 100,
        renderCell: (params) => (
          <>
          {params.row.rev_default == 1 && (
              
              <CheckCircleIcon  sx={{ fontSize: 20 }}/>
            
          )}

          
          </>
          
        ),
    },
    { field: 'rev', headerName: 'Rev#', width: 50 },
    { field: 'tanggal', headerName: 'Date', width: 100 },
    { field: 'createdAt', headerName: 'Created Date', width: 200 },
    { field: 'total', headerName: 'Total', width: 150, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
    { field: 'total_all', headerName: 'Grand Total', width: 150, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
    { field: 'persentase', headerName: 'INV', width: 50 },
    { field: 'deskripsi', headerName: 'Descriptions', width: 200 },
     
  ];

  async function handleDeleteRev(id, revDefault){
    try{
        const response = await AxiosFetchData.delete(`DeleteRev/${id}/${revDefault}`).refreshToken(Navigate)
        if(response){
            setmessage(response.data.msg)
            if(response.data.value == 0){
                await GetRev();
                return;
            }

            setTimeout(() => {
                Navigate(`/EditInvoice/${id}?ReturnUrl=${myParam}`)
            }, 300);
            
        }
    }catch(err){
        setmessage(err.message)
    }
        
  }
  const settings = { wrapMode: 'Content' };
    return (
      <Layout message={message} setmessage={setmessage}>
  <div className='pd' style={{position:'relative'}}><b>#{invoiceCode} [Rev.{rev}]</b> 
  <div  style={{position:'absolute', right:0, top:0}}>
                    <div className='text-right' >
                     <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(evt) => handleClick(evt)}
                        disabled={isLastId}
                      >
                      <MoreVertIcon sx={{ fontSize: 30 }}/>
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem   onClick={() => handleRev('add')} ><AddIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NEW REVISION</MenuItem>
                        <MenuItem   onClick={() => handleRev('remove')} ><RemoveIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CANCEL REVISION</MenuItem>
                        <MenuItem   onClick={() => handleDefault()} ><CheckCircleIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SET DEFAULT PO</MenuItem>
                      
                      </Menu>
                      
                  </div>
                </div>
  </div>
 
  <div className="pd"  id='dialog-target'>
  <div>
                <div  style={{backgroundColor:"white" }} >
                <h3>Revision History    </h3>
                  <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
                    <DataGrid rows={revRows}  columns={revColumns}  className='fonty' getRowId={(row) => row.id} />  
                  </Box>
                </div>
          </div>
           <div style={{display:"flex", width:"100%"}}>
            <div style={{marginTop:5,marginBottom:10, width:"50%"}}>
            <ConfirmationButton   disabled={roleAccess.UPDATE == true ? (isLastId) : !roleAccess.UPDATE} classname='btn btn-primary' text="Do you want save this data?" type="button" title="Save"  onClick={() => AddParentTask()} >
                      UPDATE
            </ConfirmationButton>
                        {/* <button onClick={() => AddParentTask()} className='btn btn-primary' style={{width:150}} disabled={isLastId}>UPDATE</button>  */}
            </div>
            
            </div>
          
           
            <div className="container-form">
              <div className="column-form">
              <label>INV</label>
                  <div style={{display: 'flex'}}>
                    <div className='col-lg-6' >
                      <input
                    type="number"
                    value={persentase}
                    name="address"
                    min ={0}
                    max = {100}
                    onChange={(e) => handleTotal(e.target.value)}
                    className='form-control'
                    required
                    disabled={isLastId}
                 />
                    </div>
                 <div   className='col-lg-6' >
                 <VirtualizedSelect 
                                       options={[{label : 'Percent (%)', value: 'Percent'},{label : 'Nominal (Rp)', value: 'Nominal'}]}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={   (option) => {setInvoiceType(option.value); setPersentase(0); setTotal(0)}}
                                       value={InvoiceType}
                                       clearable={false}
                                       searchable={true}
                                       required
                                       disabled={isLastId}
                                    />
                 </div>
                 
                  </div> 
              
                </div>
                
                <div className="column-form"> 
                <label >INV NO.</label>
                <div style={{display: 'flex'}}>
                     <span style={{fontSize:14}}>{invoiceCode.split('/')[0]}/MS/&nbsp;</span>
                     <input
                        type="text"
                        value={customer}
                        name="inNo"
            
                        onChange={(e) => setCustomer(e.target.value)}
                   // placeholder="Enter the purchase No."
                        className='form-control'
                         style={{width:100, height:25}}
                        required
                        disabled={customer ? true : false}
                       // style={{margin:5}}
                    />&nbsp;
                    <span style={{fontSize:14}}>/ {invoiceCode.split('/')[3]} /{invoiceCode.split('/')[4]} </span>
                </div>
                  
                </div>

                <div className="column-form"> 
                <label >Description</label>
                  <input
                   
                    type="text"
                    value={description}
                    name="address"
            
                     onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter the description."
                    className='form-control'
                    fullWidth
                    required
                    disabled={isLastId}
                  />
                </div>
          </div>
          
         
            {/* <div id='tree'>
                <TreeViewComponent fields={fields} allowEditing={true} nodeEdited={editing.bind(this)} allowDragAndDrop={true} nodeDropped={dragdrop.bind(this)} ref={(treeview) => { treeObj = treeview; }} nodeClicked={nodeclicked.bind(this)} nodeCollapsed={collapse.bind(this)} nodeExpanded={expanded.bind(this)} nodeTemplate={nodeTemplate} />
                <ContextMenuComponent id="contentmenutree" target='#tree' items={menuItems} beforeOpen={beforeopen.bind(this)} select={menuclick.bind(this)} ref={(contextmenu) => { menuObj = contextmenu; }}/>
            </div> */}
           
            <div>
              <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='300'   enableCollapseAll={false}   editSettings={editOptions} toolbar={toolbarOptions} ref={g => treegrid = g} actionBegin={actionBegin} actionComplete={actionComplete} allowRowDragAndDrop={true} rowDrop={rowDrop.bind(this)} disabled={isLastId} toolbarClick={toolbarClick} allowTextWrap={true} textWrapSettings={settings}>
                 <ColumnsDirective>
                    {/* <ColumnDirective field='rowNumber' headerText='No' width='70' textAlign='Left'  /> */}
                    <ColumnDirective field='invoice_id' headerText='ID' width='150' textAlign='Right' isPrimaryKey={true}  visible={false}/>
                    <ColumnDirective field='part_no' headerText='Part No.' width='300'/>
                    <ColumnDirective field='descriptions' headerText='Description' width='250'  textAlign='Left' />
                     <ColumnDirective field='unit_name' headerText='Unit' width='100'  textAlign='Right' />
                    <ColumnDirective field='newqty' headerText='Qty' width='130'  textAlign='Right' />
                    <ColumnDirective field='price' headerText='Price' width='130'  textAlign='Right' valueAccessor={priceTemplate}/>
                    <ColumnDirective field='total' headerText='Total' width='250' template={TotalTemplate} textAlign='Center'/>
                    <ColumnDirective field='code' headerText='Code' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='rev' headerText='Rev' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='type' headerText='type' width='350'  textAlign='Left' visible={false}/>
{/*                     
                    <ColumnDirective field='Action 1' headerText='Add Parent' width='120' textAlign='Right'/>
                    <ColumnDirective field='Action 2' headerText='Add Sub' width='100' textAlign='Right'/>
                    <ColumnDirective field='Edit' headerText='Edit Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Delete' headerText='Delete Task' width='100' textAlign='Right'/> */}
                </ColumnsDirective>
                <AggregatesDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom1}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom2}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom3}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                </AggregatesDirective>
                <Inject services={[Edit, Toolbar, RowDD, Aggregate]}/>
            </TreeGridComponent>;
            </div>
            
            <Modal
              open={confirmTaskOpen}
              onClose={() => setConfirmTaskOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
          <Box className='modals' >
          {/* <Typography id="modal-modal-title">
            <h4>Detail</h4>
          </Typography> */}
          
          <Typography id="modal-modal-description">
            <form onSubmit={AddTask} role="form">
            <div class="row">
            <div class="col-md-12">
            <label>Type</label>
            <VirtualizedSelect
                         options={typeList}
                         onChange={(option) => setSelectedType(option.value)}
                         value={selectedType}
                        clearable={false}
                        searchable={true}
                         placeholder="Type"
                        required
                    /> 
            </div>
             </div>
          <div class="row">
            <div class="col-md-12">
                <label>Part No</label>
                <input
                      type="text"
                      className="form-control"
                      placeholder="Part No"
                      required
                      value={partNo}
                      onChange={(e) => setPartNo(e.target.value)}
                    />
            </div>
             
         </div>
         {selectedType == 1 && (
            <div>
         
         <div class="row">
            <div class="col-md-6">
                <label>Description</label><br></br>
                <input
                      type="text"
                      className="form-control"
                      placeholder="Description"
                      required
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Qty</label><br></br>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Qty"
                      max={100}
                      min={0}
                      value={qty}
                      onChange={(e) => setQty(e.target.value)}
                      required
                    />

                </div>


                
            </div>
         </div>

         <div class="row">
            <div class="col-md-6">
            <label>Price</label>
            <input
                      type="number"
                      className="form-control"
                      placeholder="Price"
                      max={100}
                      min={0}
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      required
                    />
            </div>
            
         </div>
          
         </div>
)} 
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
            <button type="submit" className="btn btn-primary">ADD TASK</button>
                 </div>
            </div>
           
         </div>
         </form>
         {/* <div class="row">
            <div class="col-md-6">
                <label>Task Name</label>
                <input type="text" class="form-control" placeholder="First name" aria-label="First name" />
            </div>
            <div class="col-md-6">
                <label>Task Name</label>
                <input type="text" class="form-control" placeholder="Last name" aria-label="Last name"/>
            </div>
         </div> */}
          </Typography>
        </Box>
</Modal>

      <Modal
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals'  >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h3>Delete   {taskName}</h3>
          </Typography>
          <Typography id="modal-modal-description">
            <p>Are you sure you want to delete this data?</p>
            <button onClick={handleDeleteConfirmation} className='submit-button'>
              Yes
            </button>
            &nbsp;
            <button
              onClick={() => setConfirmDeleteOpen(false)}
              className='close-button'
            >
              No
            </button>
          </Typography>
        </Box>
      </Modal>  
    </div>
          <PrintPreview id={id} open={open} setopen={setOpen}>
              {treedata}
          </PrintPreview>
 </Layout>
       
    );
}
 

export default EditInvoice;